import { WSCard, WSList, WSText } from "@wingspanhq/fe-component-library";
import type { insuranceMonitorSettingsApiSpec } from "@wingspanhq/wingspan-api-types";

import { RequirementInstructionsView } from "../../../../Requirements/components/RequirementInstructionsView/RequirementInstructionsView";
import { selectorMasterPolicyNameByPolicyType } from "../../../../Requirements/selectors/selectorMasterPolicyNameByPolicyType";
import { INSURANCE } from "../constants";

export const InsuranceInstructionsView: React.FC<{
  allowMasterPolicy?: boolean;
  policyTypes: insuranceMonitorSettingsApiSpec.PolicyType[] | undefined;
  insuranceName: string;
}> = ({ allowMasterPolicy, insuranceName, policyTypes }) => {
  const uploadOptionWithoutMp = INSURANCE.uploadUserPolicyOption;

  const masterPolicyName = selectorMasterPolicyNameByPolicyType(policyTypes);

  return (
    <>
      <WSList>
        <WSText.Paragraph weight="medium">
          Requirement Guide for {insuranceName}
        </WSText.Paragraph>
        {allowMasterPolicy ? (
          <>
            <WSText.ParagraphSm>
              You can fulfill this requirement in two ways:
            </WSText.ParagraphSm>
            <WSText.ParagraphSm ml="M">
              1. Enroll in Wingspan's Master Policy
            </WSText.ParagraphSm>
            <WSText.ParagraphSm ml="M">
              2. Upload your own Certificate of Insurance (COI)
            </WSText.ParagraphSm>
            <WSText.ParagraphSm>
              Review the verification details below, then choose your preferred
              method on the next page.
            </WSText.ParagraphSm>
          </>
        ) : (
          <WSText.ParagraphSm>
            Upload a valid Certificate of Insurance (COI) that meets the
            client's requirements.
          </WSText.ParagraphSm>
        )}

        {/* Option without master policy */}
        {!allowMasterPolicy && (
          <WSCard pb="NONE">
            <RequirementInstructionsView instructions={uploadOptionWithoutMp} />
          </WSCard>
        )}

        {/* Option with master policy */}
        {allowMasterPolicy && (
          <>
            <WSCard pb="NONE">
              <RequirementInstructionsView
                instructions={INSURANCE.masterPolicyOption(
                  masterPolicyName || insuranceName
                )}
              />
            </WSCard>

            <WSText.Paragraph color="gray500">OR</WSText.Paragraph>

            <WSCard pb="NONE">
              <RequirementInstructionsView
                instructions={uploadOptionWithoutMp}
              />
            </WSCard>
          </>
        )}
      </WSList>
    </>
  );
};
